<template>
  <button class="tab-btn">
    <a v-show="!result" class="hint-id"><i>{{ hintID }}</i></a>
    <a v-show="result" class="hint-id"><i>{{ result }}</i></a>
    <br>
    <slot/>
    <a class="copy-to-clipboard" v-on:click="copy_to_clipboard()">⎘</a>
  </button>
</template>

<script>
export default {
  name: 'EditorButton',
  props: {
    hintID: {
      type: Number
    },
    result: {
      type: String,
      default: ""
    }
  },
  methods: {
    copy_to_clipboard() {
      navigator.clipboard.writeText(this.hintID).then(
      () => {
        this.result = "Copied!"
        setTimeout(() => {
          this.result = ""
        }, 1000)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@use '../../styles/variables' as v

.tab-btn
  background: none
  border: none
  padding: 0px 8px 4px
  font-family: v.$font-family
  font-size: v.$font-size-small
  color: v.$gray
  height: 100%
  transition: color 0.15s ease-in-out
  outline: none
  display: block
  position: relative

  &:not(.active):hover
    color: v.$white

  &:hover
    background-color: v.$light-black3

  &.active
    color: v.$white
    //background-color: v.$light-black
    border-color: v.$sharp-blue

  &.highlight
    color: v.$yellow !important
  /* TODO: get rid of !important */

  &.error
    padding: 10px 6px 6px
    border: 2px dashed v.$red

  &.ohm:before
    position: absolute
    content: 'Ω'
    top: 5px
    left: 3px
    line-height: v.$font-size-tiny
    font-size: v.$font-size-tiny

.hint-id
  text-align: center
  margin-bottom: 0px
  padding: 0px 8px 0px 8px
  padding-bottom: 0px
  line-height: v.$font-size-tiny
  font-size: v.$font-size-tiny

.copy-to-clipboard
  display: none
  position: absolute
  top: 4px
  right: 3px
  line-height: v.$font-size-tiny
  font-size: v.$font-size-tiny

.active .copy-to-clipboard
  display: block

.invisible
  visibility: hidden
  height: 0px
  min-height: 0px
  max-height: 0px

</style>
